import React, { useState, useEffect, useLayoutEffect } from "react";
import {
  ImageBackground,
  Platform,
  RefreshControl,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import typo from "../../Theme/Typo";
import Timeline from "react-native-timeline-flatlist";
import Colors from "../../Theme/Colors";
import CalendarStrip from "react-native-calendar-strip";
import { format } from "date-fns";
import Queries from "../../api/queries";
import { BookingEvent } from "../../api/type/type";
import ExportCalendar from "../utils/ExportCalendar";
import "moment/locale/fr";
import { parseISO } from "date-fns";
import ModalQLerr from "../../utils/ModalQLerr";

const colors = {
  10: "grey",
  20: "#29B2DA",
  25: "red",
  30: "#ff5d00",
  40: "#51CA30",
};

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const locale = {
  name: "fr",
  config: {
    months:
      "Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre".split(
        "_"
      ),
    monthsShort: "Janv_Févr_Mars_Avr_Mai_Juin_Juil_Août_Sept_Oct_Nov_Déc".split(
      "_"
    ),
    weekdays: "Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi".split("_"),
    weekdaysShort: "Dim_Lun_Mar_Mer_Jeu_Ven_Sam".split("_"),
    weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY LT",
      LLLL: "dddd D MMMM YYYY LT",
    },
    calendar: {
      sameDay: "[Aujourd'hui à] LT",
      nextDay: "[Demain à] LT",
      nextWeek: "dddd [à] LT",
      lastDay: "[Hier à] LT",
      lastWeek: "dddd [dernier à] LT",
      sameElse: "L",
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "une année",
      yy: "%d années",
    },
    ordinalParse: /\d{1,2}(er|ème)/,
    ordinal: function (number) {
      return number + (number === 1 ? "er" : "ème");
    },
    meridiemParse: /PD|MD/,
    isPM: function (input) {
      return input.charAt(0) === "M";
    },
    // in case the meridiem units are not separated around 12, then implement
    // this function (look at locale/id.js for an example)
    // meridiemHour : function (hour, meridiem) {
    //     return /* 0-23 hour, given meridiem token and hour 1-12 */
    // },
    meridiem: function (hours, minutes, isLower) {
      return hours < 12 ? "PD" : "MD";
    },
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  },
};

const Agenda = ({ navigation }) => {
  const [dateSelected, setDateSelected] = useState<string>(
    format(new Date(), "yyyy-MM-dd")
  );
  const queries = new Queries();

  const [QLerror, setQLerror] = useState("");

  const [eventOnDay, setEventOnDay] = useState([]);
  const [marketDates, setMarketDates] = useState([]);
  const [isRefreshingBooking, setRefreshBooking] = useState<boolean>(false);

  useEffect(() => {
    getEventDay();
  }, [dateSelected]);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <View
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            alignContent: "center",
          }}
        >
          <ExportCalendar date={new Date(dateSelected)} />
        </View>
      ),
    });
  }, [navigation, dateSelected]);

  useEffect(() => {
    getDatesMarket(dateSelected);
    getEventDay();
  }, []);

  const getEventDay = async () => {
    let events: any = [];

    try {
      const responseGraphql = await queries.getBookingEvent(dateSelected);

      let errors = responseGraphql?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        const { bookingDay }: BookingEvent =
          responseGraphql.data.getBookingEvent;

        events = bookingDay;
      }
    } catch (err) {
      setQLerror(err);
    }

    const newEvent = events.map((event) => {
      let style;
      let text = event.name;
      if (event.canceled) {
        style = { textDecorationLine: "line-through", color: "red" };
        text += " (annulé)";
      } else if (event.colorCircle == "#51CA30") {
        /*event finished*/ style = { color: "#51CA30" };
        text += " (terminé)";
      } else if (event.colorCircle == "#29B2DA") {
        style = { color: "#29B2DA" };
        text += " (en cours)";
      } else if (event.colorCircle == "#ff5d00") {
        style = { color: "#ff5d00" };
        text += " (terminé + incident déclaré)";
      }
      return {
        id: event.id,
        hour: Number(format(parseISO(event.dateStart), "HH:mm").split(":")[0]),
        time: format(parseISO(event.dateStart), "HH:mm"),
        title: <Text style={style}>{text}</Text>,
        description: !event.canceled ? (
          `Appartement: ${event.appartName}\n${event.description.lentgh > 0 ? `description: ${event.com}` : ""
          }`
        ) : (
          <Text style={{ color: "red", marginBottom: 15 }}>
            L'évènement a été annulé
          </Text>
        ),
        circleColor: event.colorCircle != "" ? event.colorCircle : Colors.oiqia,
      };
    });

    setEventOnDay(newEvent);
  };

  const getDatesMarket = async (newDate: string) => {
    const dateMaker: any = [];
    let events: any = [];

    try {
      const result = await queries.getMarkedEvents(newDate);

      let errors = result?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        events = result.data.getMarkedEvent.events;
      }
    } catch (err) {
      console.log("graphql error"); // JSON.stringify(err, null, 2
      setQLerror(err);
    }

    events.forEach((element) => {
      const sameDate = dateMaker.filter(
        (marked) => marked.date == element.date
      );
      if (sameDate.length > 0) {
        dateMaker.forEach((marked) => {
          if (marked.date == element.date) {
            marked.dots.push({ color: colors[element.lastStatus] });
          }
          return element;
        });
      } else {
        dateMaker.push({
          date: element.date,
          dots: [
            {
              color: colors[element.lastStatus],
            },
          ],
        });
      }
    });
    setMarketDates(dateMaker);
  };

  const modifyDate = (newDate: Date) => {
    const newDateMonth = newDate.getMonth();
    const currentDateMonth = new Date(dateSelected).getMonth();
    if (newDateMonth != currentDateMonth) {
      getDatesMarket(format(newDate, "yyyy-MM-dd"));
    }
    setDateSelected(format(newDate, "yyyy-MM-dd"));
  };

  return (
    <SafeAreaView style={typo.mainBackground}>
      <ImageBackground source={BG_PATH} style={typo.background}>
        <ScrollView
          refreshControl={
            <RefreshControl
              refreshing={isRefreshingBooking}
              onRefresh={() => {
                getDatesMarket(dateSelected).finally(() =>
                  getEventDay().finally(() => setRefreshBooking(false))
                );
              }}
            />
          }
        >
          {QLerror && QLerror !== "" ? (
            <ModalQLerr reason={QLerror} resetErr={() => setQLerror("")} />
          ) : null}
          <CalendarStrip
            locale={locale}
            scrollable
            selectedDate={new Date(dateSelected)}
            calendarAnimation={{ type: "sequence", duration: 30 }}
            daySelectionAnimation={{
              type: "border",
              duration: 200,
              borderWidth: 1,
              borderHighlightColor: "white",
            }}
            onDateSelected={(date: any) => modifyDate(new Date(date))}
            style={{ height: 100, marginTop: 10 }}
            calendarHeaderStyle={{ color: "white", fontSize: 16 }}
            highlightDateContainerStyle={{ backgroundColor: "white" }}
            dateNumberStyle={{ color: "white", fontSize: 14 }}
            dateNameStyle={{ color: "white", fontSize: 14 }}
            markedDates={marketDates}
            calendarColor={Platform.OS != "web" ? "#FFFFFF00" : Colors.oiqia}

            highlightDateNumberStyle={{ fontSize: 16 }}
            highlightDateNameStyle={{ fontSize: 14 }}
            disabledDateNameStyle={{ fontSize: 12 }}
            disabledDateNumberStyle={{ fontSize: 12 }}

          />

          <View
            style={[
              typo.resCard,
              { margin: 10, marginTop: 10, justifyContent: "center" },
            ]}
          >
            {eventOnDay.length > 0 ? (

              <Timeline
                titleStyle={{ color: "black" }}
                data={eventOnDay}
                circleSize={20}
                circleColor={Colors.oiqia}
                lineColor={Colors.darkGrey}
                timeContainerStyle={{ minWidth: 52, marginTop: -4 }}
                timeStyle={{
                  textAlign: "center",
                  backgroundColor: Colors.oiqia,
                  color: "white",
                  padding: 5,
                  borderRadius: 13,

                }}
                descriptionStyle={{ color: "black"}}
                options={{
                  style: { paddingTop: 5 },
                }}
                onEventPress={(event) =>
                  navigation.navigate("TodoScreen", { eventId: event.id })
                }
              // columnFormat='two-column'
              />
            ) : (
              <View>
                <Text style={typo.body}>
                  Aucun évènement pour le jour selectionné
                </Text>
              </View>
            )}
          </View>
        </ScrollView>
      </ImageBackground>
    </SafeAreaView>
  );
};

const style = StyleSheet.create({
  center: {
    flex: 1,
    justifyContent: "flex-end",
  },
  titleWelcome: {
    fontSize: 18,
    color: "black",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "RobotoMedium",
  },
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  column: {
    flex: 1,
    alignSelf: "auto",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  dateInfo: {
    width: "50%",
    padding: 5,
    textAlign: "left",

    justifyContent: "flex-start",
  },
  underline: {
    borderColor: "#0A0A0AE7",
    borderBottomWidth: 0.5,
    paddingBottom: 5,
    marginBottom: 10,
  },
});

export default Agenda;
